/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ApiTestSelettivaTestPost$Params {
    /**
     * Id dell'utente a cui inviare la notifica
     */
    utenteId: number;

    /**
     * True se inviare una notifica secondaria
     */
    secondaryNotification?: boolean;
}

export function apiTestSelettivaTestPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiTestSelettivaTestPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(rootUrl, apiTestSelettivaTestPost.PATH, 'post');
    if (params) {
        rb.query('utenteId', params.utenteId, {});
        rb.query('secondaryNotification', params.secondaryNotification, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: String((r as HttpResponse<any>).body) === 'true',
            }) as StrictHttpResponse<boolean>;
        }),
    );
}

apiTestSelettivaTestPost.PATH = '/api/test/selettiva-test';
